import { STORE_EXCHANGE } from 'app/constants/LOCALKEYS'
import useSWR from 'swr'
import { getPersistData } from '../persist'
import { useToken } from '../auth/token'
import API from '../../../utils/api'
import { useMemo } from 'react'
import { API_COINURL } from '../../constants/APIKEYS'
import { useCoinGlobal } from '../stateStore/coinGlobal'

const KEY = STORE_EXCHANGE

let swrData: any = getPersistData(KEY) || [] // 시크릿 모드 대비 기본값 설정

export function useExchangeStore(isall = false) {
	const { data: coinglobal } = useCoinGlobal()

	const { data: token } = useToken()
	const { data, mutate } = useSWR<any>(KEY + coinglobal+isall, async () => {
		const result = await API.get(
			'/exchanges?id=0&isall=' + (isall ? 1 : 0),
			token + '',
			{},
			false,
			coinglobal == 'C' ? API_COINURL : undefined
		)
		// API 응답이 배열인지 확인하고 배열이 아닌 경우 빈 배열로 설정
		swrData = Array.isArray(result.result) ? result.result : []

		return swrData
	}, {
		refreshInterval: 1000 * 60 * 5, // 5분마다 갱신 (기존 1시간 → 5분)
		dedupingInterval: 1000*20,
		revalidateOnMount: true, // 마운트 시 항상 최신 데이터 가져오기
		revalidateOnFocus: false, // 시크릿 모드 대비: 포커스 시 재검증 비활성화
		fallbackData: swrData || [], // 시크릿 모드 대비: fallback 데이터 설정
	})

	const EPs = useMemo(
		() =>
			(Array.isArray(data) ? data : [])?.filter((item: any) => {
				const now = new Date()
				// - 를 / 로 변경
				const enddate = new Date(
					item?.enddate?.replace(/-/g, '/') + ' 23:59:59'
				)

				return enddate >= now
			}),
		[data, coinglobal, isall]
	)

	return {
		data: Array.isArray(data) ? data : [],
		EPs: EPs,
		mutate: (value?: any) => {
			if (value !== undefined) swrData = value
			return mutate()
		},
	}
}
